"use strict";
/**
 * API Contracts
 * Request and Response types for all API endpoints
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./collaborator"), exports);
__exportStar(require("./employment"), exports);
__exportStar(require("./catalog-item"), exports);
__exportStar(require("./order-planning"), exports);
__exportStar(require("./qvet"), exports);
__exportStar(require("./stock-calculation"), exports);
__exportStar(require("./cash-reconciliation"), exports);
__exportStar(require("./time-off-request"), exports);
__exportStar(require("./force-majeure"), exports);
__exportStar(require("./job"), exports);
__exportStar(require("./inventory-session"), exports);
__exportStar(require("./shift-checklist"), exports);
__exportStar(require("./client-billing"), exports);
__exportStar(require("./global-invoice"), exports);
__exportStar(require("./inventory-report"), exports);
__exportStar(require("./google-contacts"), exports);
__exportStar(require("./google-calendar"), exports);
__exportStar(require("./study-type-catalog"), exports);
__exportStar(require("./supplier-overlay"), exports);
__exportStar(require("./external-study"), exports);
__exportStar(require("./pending-dashboard"), exports);
__exportStar(require("./document"), exports);
__exportStar(require("./supplier-orders"), exports);
__exportStar(require("./supplier-payments"), exports);
__exportStar(require("./supplier-linking"), exports);
__exportStar(require("./commission-reconciliation"), exports);
__exportStar(require("./sitpv"), exports);
